import { Text } from 'components';
import { PricingType } from './types';
import { useTranslation } from 'react-i18next';

type Props = PricingType;

const PricingButton = ({ title, description, price, onClick }: Props) => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      className="cursor-default relative flex h-40 flex-col items-start justify-end gap-1 overflow-hidden rounded-lg border border-border-primary bg-white p-4"
      onClick={onClick}
    >
      <div className="z-10 flex h-40 flex-col items-start justify-end gap-1">
        <Text size="body2" color="description" weight="regular">
          {t(title)}
        </Text>
        <Text size="heading3" color="black" weight="regular">
          {t(price)}
        </Text>
        <Text size="body2" color="description" weight="regular" className="max-w-[400px] text-left">
          {t(description)}
        </Text>
      </div>
    </button>
  );
};

export default PricingButton;
